export const chartModesConstants = {
    Analysis: 'analysis',
    Comparison: 'comparison',
};
